import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { AGENT_DISPLAY_NAMES, AGENT_ID_TO_ROUTE } from "@/lib/agent-ids";

interface AgentLockBannerProps {
  dependencyIds: string[];
}

export function AgentLockBanner({ dependencyIds }: AgentLockBannerProps) {
  if (dependencyIds.length === 0) return null;

  return (
    <div className="rounded-lg border border-muted bg-muted/50 p-4 flex items-start gap-3">
      <Lock className="h-5 w-5 text-muted-foreground shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-medium text-foreground">This agent is locked</p>
        <p className="text-xs text-muted-foreground mt-1">
          Waiting for{" "}
          {dependencyIds.map((id, i) => {
            const name = AGENT_DISPLAY_NAMES[id] || id;
            const route = AGENT_ID_TO_ROUTE[id] || id;
            return (
              <span key={id}>
                {i > 0 && (i === dependencyIds.length - 1 ? " and " : ", ")}
                <Link
                  to={`../agents/${route}`}
                  className="text-primary font-medium hover:underline"
                >
                  {name}
                </Link>
              </span>
            );
          })}{" "}
          to complete before this agent can start.
        </p>
      </div>
    </div>
  );
}
